/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BatchDto,
  BatchListDto,
  BatchesControllerListParams,
  CreateBatchDto,
  PatchBatchStatusDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * admin sees all; coop_admin sees batches in cooperatives they admin, group_lead sees their informal group's batches (groups table, lead_user_id = caller; TD-057, resolved via the batch_owner view); farmer (informal_group member) sees their own group's batches read-only (zero rows otherwise). Optional status filter. Order: most recent opened first.
 * @summary List batches (paginated, coop-scoped)
 */
export const batchesControllerList = (
    params?: BatchesControllerListParams,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<BatchListDto>(
      {url: `/batches`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getBatchesControllerListQueryKey = (params?: BatchesControllerListParams,) => {
    return [
    `/batches`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBatchesControllerListQueryOptions = <TData = Awaited<ReturnType<typeof batchesControllerList>>, TError = unknown>(params?: BatchesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchesControllerList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBatchesControllerListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof batchesControllerList>>> = ({ signal }) => batchesControllerList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof batchesControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BatchesControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof batchesControllerList>>>
export type BatchesControllerListQueryError = unknown


export function useBatchesControllerList<TData = Awaited<ReturnType<typeof batchesControllerList>>, TError = unknown>(
 params: undefined |  BatchesControllerListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchesControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof batchesControllerList>>,
          TError,
          Awaited<ReturnType<typeof batchesControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBatchesControllerList<TData = Awaited<ReturnType<typeof batchesControllerList>>, TError = unknown>(
 params?: BatchesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchesControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof batchesControllerList>>,
          TError,
          Awaited<ReturnType<typeof batchesControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBatchesControllerList<TData = Awaited<ReturnType<typeof batchesControllerList>>, TError = unknown>(
 params?: BatchesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchesControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List batches (paginated, coop-scoped)
 */

export function useBatchesControllerList<TData = Awaited<ReturnType<typeof batchesControllerList>>, TError = unknown>(
 params?: BatchesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchesControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBatchesControllerListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * cooperative_id is derived from cooperatives.admin_user_id = caller (a group_lead resolves their is_formal=false group). A caller who admins zero cooperatives gets a 400. Initial status=open, total_kg=0.
 * @summary Open a new batch in the caller's cooperative
 */
export const batchesControllerCreate = (
    createBatchDto: CreateBatchDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<BatchDto>(
      {url: `/batches`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBatchDto, signal
    },
      );
    }
  


export const getBatchesControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchesControllerCreate>>, TError,{data: CreateBatchDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof batchesControllerCreate>>, TError,{data: CreateBatchDto}, TContext> => {

const mutationKey = ['batchesControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof batchesControllerCreate>>, {data: CreateBatchDto}> = (props) => {
          const {data} = props ?? {};

          return  batchesControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BatchesControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof batchesControllerCreate>>>
    export type BatchesControllerCreateMutationBody = CreateBatchDto
    export type BatchesControllerCreateMutationError = unknown

    /**
 * @summary Open a new batch in the caller's cooperative
 */
export const useBatchesControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchesControllerCreate>>, TError,{data: CreateBatchDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof batchesControllerCreate>>,
        TError,
        {data: CreateBatchDto},
        TContext
      > => {

      const mutationOptions = getBatchesControllerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Read a single batch by id
 */
export const batchesControllerGetOne = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<BatchDto>(
      {url: `/batches/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getBatchesControllerGetOneQueryKey = (id?: string,) => {
    return [
    `/batches/${id}`
    ] as const;
    }

    
export const getBatchesControllerGetOneQueryOptions = <TData = Awaited<ReturnType<typeof batchesControllerGetOne>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchesControllerGetOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBatchesControllerGetOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof batchesControllerGetOne>>> = ({ signal }) => batchesControllerGetOne(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof batchesControllerGetOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BatchesControllerGetOneQueryResult = NonNullable<Awaited<ReturnType<typeof batchesControllerGetOne>>>
export type BatchesControllerGetOneQueryError = unknown


export function useBatchesControllerGetOne<TData = Awaited<ReturnType<typeof batchesControllerGetOne>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchesControllerGetOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof batchesControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof batchesControllerGetOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBatchesControllerGetOne<TData = Awaited<ReturnType<typeof batchesControllerGetOne>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchesControllerGetOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof batchesControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof batchesControllerGetOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBatchesControllerGetOne<TData = Awaited<ReturnType<typeof batchesControllerGetOne>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchesControllerGetOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Read a single batch by id
 */

export function useBatchesControllerGetOne<TData = Awaited<ReturnType<typeof batchesControllerGetOne>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchesControllerGetOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBatchesControllerGetOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Allowed transitions: open→locked|cancelled; locked→open|sold|cancelled; sold→settled. Anything else returns 400. coop_admin / group_lead must admin this batch's cooperative.
 * @summary Transition status (open|locked|sold|settled|cancelled)
 */
export const batchesControllerPatch = (
    id: string,
    patchBatchStatusDto: PatchBatchStatusDto,
 ) => {
      
      
      return fseAxios<BatchDto>(
      {url: `/batches/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchBatchStatusDto
    },
      );
    }
  


export const getBatchesControllerPatchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchesControllerPatch>>, TError,{id: string;data: PatchBatchStatusDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof batchesControllerPatch>>, TError,{id: string;data: PatchBatchStatusDto}, TContext> => {

const mutationKey = ['batchesControllerPatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof batchesControllerPatch>>, {id: string;data: PatchBatchStatusDto}> = (props) => {
          const {id,data} = props ?? {};

          return  batchesControllerPatch(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BatchesControllerPatchMutationResult = NonNullable<Awaited<ReturnType<typeof batchesControllerPatch>>>
    export type BatchesControllerPatchMutationBody = PatchBatchStatusDto
    export type BatchesControllerPatchMutationError = unknown

    /**
 * @summary Transition status (open|locked|sold|settled|cancelled)
 */
export const useBatchesControllerPatch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchesControllerPatch>>, TError,{id: string;data: PatchBatchStatusDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof batchesControllerPatch>>,
        TError,
        {id: string;data: PatchBatchStatusDto},
        TContext
      > => {

      const mutationOptions = getBatchesControllerPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Sets locked_at = now(). Same semantics as PATCH /batches/:id with body {status:"locked"}.
 * @summary Convenience: transition open → locked
 */
export const batchesControllerLock = (
    id: string,
 ) => {
      
      
      return fseAxios<BatchDto>(
      {url: `/batches/${id}/lock`, method: 'PATCH'
    },
      );
    }
  


export const getBatchesControllerLockMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchesControllerLock>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof batchesControllerLock>>, TError,{id: string}, TContext> => {

const mutationKey = ['batchesControllerLock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof batchesControllerLock>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  batchesControllerLock(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BatchesControllerLockMutationResult = NonNullable<Awaited<ReturnType<typeof batchesControllerLock>>>
    
    export type BatchesControllerLockMutationError = unknown

    /**
 * @summary Convenience: transition open → locked
 */
export const useBatchesControllerLock = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchesControllerLock>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof batchesControllerLock>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getBatchesControllerLockMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    